import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Suspense } from "react";

export default function MainLayout() {
  return (
    <>
      {/* ✅ HEADER (semantic) */}
      <header>
        <Navbar />
      </header>

      {/* ✅ MAIN CONTENT (critical for SEO) */}
      <main>
        <Suspense fallback={<div style={{ minHeight: "100vh" }} />}>
          <Outlet />
        </Suspense>
      </main>

      {/* ✅ FOOTER (semantic) */}
      <footer>
        <Footer />
      </footer>
    </>
  );
}